import type { ReactNode } from 'react';
import nullthrows from 'nullthrows';

import { ProgressiveRolloutVariationDisplay } from '#components/automated-rollouts/progressive-rollouts/ProgressiveRolloutVariationDisplay';
import type { Flag } from '#utils/flags/records/Flag';

import styles from './StopProgressiveRolloutInstructionEntry.module.css';

export function StopProgressiveRolloutInstructionEntry({
  flag,
  environmentKey,
  ruleIdOrFallthrough,
  endVariationId,
}: {
  flag: Flag;
  environmentKey: string;
  ruleIdOrFallthrough: string;
  endVariationId?: string;
}) {
  let ruleName: string;

  if (ruleIdOrFallthrough === 'fallthrough') {
    ruleName = 'default rule';
  } else {
    const ruleIndex = flag.getRuleIndex(environmentKey, ruleIdOrFallthrough);
    if (ruleIndex > -1) {
      const rule = nullthrows(
        flag.getRules(environmentKey)?.get(ruleIndex),
        `expected flag to have rule in environment with key "${environmentKey}" at index ${ruleIndex}`,
      );
      ruleName = rule.description || `Rule ${ruleIndex + 1}`;
    } else {
      ruleName = 'Rule not found';
    }
  }

  let variationDisplay: ReactNode;

  if (endVariationId) {
    const variationIndex = flag.getVariationIndexFromId(endVariationId);
    if (variationIndex > -1) {
      variationDisplay = (
        <ProgressiveRolloutVariationDisplay
          variation={nullthrows(flag.variations.get(variationIndex))}
          variationIndex={variationIndex}
        />
      );
    } else {
      variationDisplay = 'Variation not found';
    }
  }

  return (
    <div>
      <div>Rule: {ruleName}</div>
      <div className={styles.serve}>Serve: {variationDisplay ?? 'No variation selected'}</div>
    </div>
  );
}
